import nextLinkGroup from 'scoreboard/datasets/filters/next-link-group'

function combineFilters(array1 = [], array2 = []) {
    if (!array1.length) return array2
    if (!array2.length) return array1

    let theNextLinkGroup = nextLinkGroup(array1)

    // Increase the linkGroup in array2 by theNextLinkGroup - 1
    array2 = array2.map(obj => {
        if (!obj.linkGroup) return obj
        return ({...obj, linkGroup: obj.linkGroup + theNextLinkGroup - 1})
    })

    // Combine the arrays
    return [...array1, ...array2]
}

export default combineFilters

combineFilters.__filename__ = 'datasets/filters/combine-filters.js'
